import { Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';

export const fatRoutes: Routes = [
  {
    path: 'monitor-mdf-e',
    loadChildren: () =>
      import('../pages/fat/monitor-mdf-e/monitor-mdf-e.module').then(
        (module) => module.MonitorMdfEModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastro-generico',
    loadChildren: () =>
      import(
        '../pages/cad/cadastro-generico/cadastro-generico.module'
      ).then((module) => module.CadastroGenericoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'monitor-notas-fiscais',
    loadChildren: () =>
      import(
        '../pages/fat/monitor-notas-fiscais/monitor-notas-fiscais.module'
      ).then((module) => module.MonitorNotasFiscaisModule),
    canActivate: [AuthGuard],
  },
  {
      path: 'indice',
      loadChildren: () =>
        import('../pages/bas/indice/indice.module').then(
          (module) => module.IndiceModule
        ),
      canActivate: [AuthGuard],
    }
];
